import React, { useContext, useState } from 'react'
import { useHistory } from 'react-router';
import { AccountContext } from '../Account/Account'
import { Form, Spinner } from "react-bootstrap";
import { types } from 'types/types';
import logo from 'assets/img/c2cLogo.png';

export const Login = () => {

   const lastPath = '/resumen';
   let history = useHistory();

   const { authenticate, dispatch } = useContext(AccountContext);
   const [email, setEmail] = useState("");
   const [password, setPassword] = useState("");
   const [error, setError] = useState("");
   const [loading, setLoading] = useState(false);

   const onSubmit = (event) => {
      event.preventDefault();
      setError("");
      setLoading(true);
      authenticate(email, password).then(data => {
         const action = {
            type: types.login,
            payload: data
         }

         dispatch(action);
         history.push(lastPath);
      }).catch(err => {
         console.error(err);
         setError(err?.message || 'No se pudo iniciar sesión. Verifica tus credenciales.');
         setLoading(false);
      })
   }

   return (
      <div className="login-page">
         <div className="login-card">
            <div className="login-card__brand">
               <img src={logo} alt="C2C" className="login-card__logo" />
            </div>
            <div className="login-card__head">
               <h1 className="login-card__title">Iniciar sesión</h1>
               <p className="login-card__subtitle">Ingresa tus credenciales para acceder al panel.</p>
            </div>

            <Form onSubmit={onSubmit} className="filter-form login-form">
               <Form.Group className="form-field" controlId="formBasicEmail">
                  <Form.Label>Correo electrónico</Form.Label>
                  <Form.Control
                     value={email}
                     onChange={(event) => setEmail(event.target.value)}
                     type="email"
                     placeholder="nombre@empresa.cl"
                     autoComplete="username"
                     required
                  />
               </Form.Group>

               <Form.Group className="form-field" controlId="formBasicPassword">
                  <Form.Label>Contraseña</Form.Label>
                  <Form.Control
                     value={password}
                     onChange={(event) => setPassword(event.target.value)}
                     type="password"
                     placeholder="Contraseña"
                     autoComplete="current-password"
                     required
                  />
               </Form.Group>

               {error && <div className="login-form__error">{error}</div>}

               <button className="btn-primary-action login-form__submit" type="submit" disabled={loading}>
                  {loading ? (
                     <>
                        <Spinner animation="border" size="sm" /> Ingresando...
                     </>
                  ) : (
                     <>
                        <i className="nc-icon nc-key-25" /> Ingresar
                     </>
                  )}
               </button>
            </Form>
         </div>
      </div>
   )
}
